import type { Env } from './environments';

export const claimUrlsIncludingPermittedVariants = (urls: Array<string>): Array<string> => [
  ...urls,
  ...urls.map((url) => `${url}/`),
];
export const getAllowedIssuers = (env: Env) => {
  switch (env) {
    case 'prod':
      return [
        'https://zus-production.us.auth0.com',
        'https://auth.zusapi.com',
        'https://api.zusapi.com/auth',
      ];
    case 'sandbox':
      return [
        'https://zus-sandbox.us.auth0.com',
        'https://auth.sandbox.zusapi.com',
        'https://api.sandbox.zusapi.com/auth',
      ];
    case 'phitest':
      return [
        'https://zus-phi-test.us.auth0.com',
        'https://auth.phitest.zusapi.com',
        'https://api.phitest.zusapi.com/auth',
      ];
    case 'dev':
      return [
        'https://zus-dev.us.auth0.com',
        'https://auth.dev.zusapi.com',
        'https://api.dev.zusapi.com/auth',
      ];
    default:
      return [];
  }
};
export const getAllowedAudiences = (env: Env) => {
  switch (env) {
    case 'prod':
      return ['https://api.zusapi.com', 'https://zus.us.auth0.com/userinfo'];
    case 'sandbox':
      return [
        'https://api.sandbox.zusapi.com',
        'https://ctw-60-second-timeout.sandbox.zusapi.com',
        'https://zus-sandbox.us.auth0.com/userinfo',
      ];
    case 'phitest':
      return ['https://api.phitest.zusapi.com', 'https://zus-phi-test.us.auth0.com/userinfo'];
    case 'dev':
      return [
        'https://api.dev.zusapi.com',
        'https://auth-service.dev.zusapi.com',
        'https://zus-dev.us.auth0.com/userinfo',
      ];
    default:
      return [];
  }
};
